import * as React from "react";
import { Selectors } from "@grandvisionhq/auth";
import { useBloomreachPageRoutes } from "@grandvisionhq/bloomreach";
import { useIntl, useSelector, useFeatureToggles } from "@grandvisionhq/state";
import { OrderCallToAction } from "../../../../components/modules/OrderCallToAction/components/OrderCallToAction.js";
const OrderCallToActionContainer = ({ isStacked }) => {
  const { getLabel } = useIntl();
  const myAccountRoutes = useSelector(Selectors.getFormattedRoutes);
  const { routes: bloomreachRoutes } = useBloomreachPageRoutes();
  const { isMyAccountEnabled } = useFeatureToggles();
  const labels = React.useMemo(
    () => ({
      continueShopping: getLabel("cart.actions.goBack"),
      visitMyAccount: getLabel("account.menu.myAccount")
    }),
    [getLabel]
  );
  const routes = React.useMemo(
    () => ({
      continueShopping: bloomreachRoutes.root ?? "",
      visitMyAccount: isMyAccountEnabled ? myAccountRoutes?.orders : void 0
    }),
    [bloomreachRoutes.root, isMyAccountEnabled, myAccountRoutes?.orders]
  );
  return /* @__PURE__ */ React.createElement(OrderCallToAction, { labels, isStacked, routes });
};
export {
  OrderCallToActionContainer
};
//# sourceMappingURL=OrderCallToActionContainer.js.map
